import { useState, useEffect } from 'react';

export function useTabWithHash(defaultTab, prefix) {
  const getFromHash = () => {
    const hash = window.location.hash.replace('#', '');
    const parts = hash.split('/');
    const part = parts.find(p => p.startsWith(prefix + ':'));
    return part ? decodeURIComponent(part.split(':')[1]) : null;
  };

  const [tab, setTabState] = useState(() => getFromHash() || defaultTab);

  useEffect(() => {
    const onHashChange = () => {
      const fromHash = getFromHash();
      if (fromHash && fromHash !== tab) setTabState(fromHash);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setTab = (key) => {
    setTabState(key);
    // Fusionner avec le hash existant sans écraser les autres segments
    const hash = window.location.hash.replace('#', '');
    const parts = hash.split('/').filter(p => p && !p.startsWith(prefix + ':'));
    parts.push(prefix + ':' + encodeURIComponent(key));
    window.location.hash = parts.join('/');
  };

  return [tab, setTab];
}
